(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stem-catalog"] && !Shopify.designMode) return;
  try {
    
  function initStemCatalog(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const concern = root.querySelector('[data-concern]');
    const type = root.querySelector('select[data-type]');
    const items = Array.from(root.querySelectorAll('.stem-catalog__item'));
    const count = root.querySelector('[data-count]');
    function update() {
      let visible = 0;
      items.forEach(item => {
        const matchesConcern = !concern.value || item.dataset.concerns.split(',').map(s => s.trim()).includes(concern.value);
        const matchesType = !type.value || item.dataset.type === type.value;
        item.hidden = !(matchesConcern && matchesType);
        if (!item.hidden) visible++;
      });
      count.textContent = count.dataset.label.replace('[count]', visible);
      root.querySelector('[data-empty]').hidden = visible !== 0;
    }
    concern.addEventListener('change', update);
    type.addEventListener('change', update);
    root.querySelector('[data-reset]').addEventListener('click', () => { concern.value = ''; type.value = ''; update(); });
    root.querySelector('.stem-catalog__filters').hidden = false;
    update();
  }
  document.querySelectorAll('[data-stem-catalog]').forEach(initStemCatalog);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-stem-catalog]').forEach(initStemCatalog); });

  } catch(e) { console.error(e); }
})();
})();
